var map = {
	"./0.jpg": "crRO",
	"./1.jpg": "L0pk",
	"./2.jpg": "Ybts",
	"./3.jpg": "OXWZ",
	"./4.jpg": "ONfx",
	"./5.jpg": "fUnh",
	"./6.jpg": "faIE",
	"./7.jpg": "IRAc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YmtO";


//////////////////
// WEBPACK FOOTER
// ./src/assets/good-fresh/fresh-images ^\.\/.*\.jpg$
// module id = YmtO
// module chunks = 1